<script>
  export default {
    name: 'u-pagination',
    props: [
      'atual',
      'total'
    ],
    data () {
      return {}
    },
    computed: {
      noPrevious () {
        if (parseInt(this.atual) === 1) return true
        return false
      },
      noNext () {
        if (parseInt(this.atual) === parseInt(this.total)) return true
        return false
      },
      totalLimited () {
        let atual = this.atual
        // let pages = []
        let limit = 10
        let qtdLeftRight = limit / 2
        // for (let i = 1; i <= this.total; i++) {
        /* let sum = atual - i
        console.log(sum, atual, i)
        // return (sum < 3 && sum >= 0) || (sum < -3 && sum <= 0)
        if ((atual - limit) < 0) {
          console.log('Menor')
          if (i < (limit + i)) {
            if (i >= atual) {
              pages.push(i)
            }
          }
        } else if ((sum < qtdLeftRight && sum >= 0) || (sum > (qtdLeftRight * -1) && sum <= 0)) {
          pages.push(i)
        } */
        /* let sum = atual - i
        if (atual < (limit / 2)) {
          if (i >= atual && atual <= (limit + (atual - 1))) {
            console.log(atual, '<=', (limit + (atual - 1)))
            pages.push(i)
          }
        } else if ((sum < qtdLeftRight && sum >= 0) || (sum > (qtdLeftRight * -1) && sum <= 0)) {
          pages.push(i)
        } */
        // }
        let pages = Array(this.total).fill().map((e, i) => i + 1)
        if (atual < qtdLeftRight) {
          pages = pages.slice(0, limit)
        } else {
          pages = pages.slice(atual - qtdLeftRight, (limit + atual) - qtdLeftRight)
        }
        return pages
      }
    },
    mounted () {
    },
    destroyed () {
    },
    methods: {
      selectPage (page, e) {
        if (page === this.atual) return
        if (page < 1 || page > this.total) return
        this.$emit('changePage', page)
      },
      isAtualPage (page) {
        if (page === this.atual) {
          return true
        }
        return false
      }
    },
    components: {}
  }
</script>

<template>
  <ul class="pagination-sm m-t-sm m-b pagination"
      aria-invalid="false">
    <!-- Seleciona a primeira -->
    <li :class="{disabled: noPrevious}"
        class="pagination-first"><a @click="selectPage(1, $event)" class="">&lt;&lt;</a></li>

    <li :class="{disabled: noPrevious}"
        class="pagination-prev"><a @click="selectPage(parseInt(atual) - 1, $event)" class="">&lt;</a>
    </li>

    <li v-for="page in totalLimited"
        :class="{active: isAtualPage(page)}"
        class="pagination-page"><a @click="selectPage(parseInt(page), $event)" class="">{{ page }}</a></li>

    <li :class="{disabled: noNext}"
        class="pagination-next"><a @click="selectPage(parseInt(atual) + 1, $event)" class="">&gt;</a>
    </li>

    <li :class="{disabled: noNext}"
        class="pagination-last"><a @click="selectPage(parseInt(total), $event)" class="">&gt;&gt;</a>
    </li>
  </ul>
</template>



// WEBPACK FOOTER //
// Pagination.vue?121f04b2